"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const mobx_1 = require("mobx");
const payAtBranch_1 = __importDefault(require("../../clients/booking/payAtBranch"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const PAYMENT_STATUS_1 = __importDefault(require("../../constants/payment/PAYMENT_STATUS"));
const PAYMENT_TYPE_1 = __importDefault(require("../../constants/payment/PAYMENT_TYPE"));
const setPaymentCookie_1 = __importDefault(require("../../utils/payment/setPaymentCookie"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Checkout using Pay At Branch Domain Store
 */
class BranchCheckoutStore {
    constructor(initialState, $env) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Makes pay at branch payment api call
         * @param {string} quoteId
         * @param {string} rtoken - Google recaptcha token
         * @param {Function} successHandler
         * @param {Function} errorHandler
         * @param {string} extraParams - rewards object
         */
        this.fetch = (0, mobx_1.flow)(function* (
        // reqParam: BranchCheckoutParamType,
        quoteId, rtoken, successHandler, errorHandler, extraParams) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const reqParam = Object.assign({ paymentType: PAYMENT_TYPE_1.default.PAY_AT_BRANCH }, extraParams);
                console.log('Pay at branch reqParam: ', reqParam);
                const response = yield (0, payAtBranch_1.default)(reqParam, quoteId, rtoken);
                // 200 http codes
                this.onSuccess(response, successHandler);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data, successHandler) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
            // add token to cookie if present
            // this is not login token
            // this token is to get booking details for non-logged in users
            // i am naming it the payment token
            const ptoken = (0, get_1.default)(data, 'token', '');
            ptoken && (0, setPaymentCookie_1.default)(ptoken);
            if (successHandler) {
                successHandler(data); // passes the response object back
            }
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns the JWT token
     * Will be used to get the booking details
     * This is mainly for non logged in users
     * For logged in users, session token can be used
     * Also for logged in users, token is not sent in response
     * Because we are already passing in Auth Header
     * @returns {string}
     */
    get token() {
        return (0, get_1.default)(this.data, 'token', '');
    }
    /**
     * Returns the reference no/quote ID
     * This will be used later to get booking details
     * @returns {string}
     */
    get referenceNo() {
        return (0, get_1.default)(this.data, 'referenceNo', '');
    }
    /**
     * Returns the displayId
     * This is used to send in GTM events
     * @returns {string}
     */
    get displayId() {
        return (0, get_1.default)(this.data, 'displayId', '');
    }
    /**
     * Returns payment status
     * @returns {string}
     */
    get paymentStatus() {
        return (0, get_1.default)(this.data, 'paymentStatus', '');
    }
    /**
     * Payment has failed if
     *  API call has given non 200 http code or
     *  API call was 200 but paymentStatus=FAILED
     * @returns {boolean}
     */
    get hasPaymentFailed() {
        return this.hasFailed || this.paymentStatus === PAYMENT_STATUS_1.default.FAILED;
    }
    /**
     * Payment is success if
     *  API call was success 200 And
     *  paymentStatus=SUCCESS
     * @returns {boolean}
     */
    get isPaymentSuccess() {
        return this.isSuccess && this.paymentStatus === PAYMENT_STATUS_1.default.SUCCESS;
    }
}
__decorate([
    mobx_1.observable
], BranchCheckoutStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], BranchCheckoutStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], BranchCheckoutStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "token", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "referenceNo", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "displayId", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "paymentStatus", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "hasPaymentFailed", null);
__decorate([
    mobx_1.computed
], BranchCheckoutStore.prototype, "isPaymentSuccess", null);
__decorate([
    mobx_1.action.bound
], BranchCheckoutStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], BranchCheckoutStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], BranchCheckoutStore.prototype, "updateInitialState", void 0);
exports.default = BranchCheckoutStore;
